import { useCallback } from 'react';
import { storage } from '../lib/storage';
import { downloadJson } from '../utils/download';
import { notify } from '../utils/toast';
import { Message } from '../types/chat';

export const useConversationExport = () => {
  const downloadConversation = useCallback(async (
    walletAddress: string,
    conversation: { id: string; title: string; created_at: string; updated_at: string },
    messages: Message[]
  ) => {
    try {
      // Create export object with conversation details and messages
      const exportData = {
        ...conversation,
        messages: messages.map(msg => ({
          id: msg.id,
          content: msg.content,
          sender: msg.sender,
          created_at: msg.created_at,
          metadata: msg.metadata
        }))
      };

      // Generate filename with conversation title and date
      const date = new Date().toISOString().split('T')[0];
      const safeTitle = conversation.title.replace(/[^a-z0-9]/gi, '_').toLowerCase();
      const filename = `conversation_${safeTitle}_${date}.json`;

      downloadJson(exportData, filename);
      notify.success('Conversation downloaded successfully');
    } catch (error) {
      console.error('Error downloading conversation:', error);
      notify.error('Failed to download conversation');
    }
  }, []);

  return { downloadConversation };
};